import { ICON_COLOR } from '@zep-us/zus/tokens';
import { MinusIcon, PlusIcon } from '@zep-us/zus-icons';
interface NumberStepperFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  onMinClick?: () => void;
}

/** 사용 인원 스텝퍼 — 라벨 + −/입력/+ (Figma "Number selector"). */
export function NumberStepperField({
  label,
  value,
  onChange,
  min = 1,
  max = 100,
  onMinClick
}: NumberStepperFieldProps) {
  const commit = (next: number) => {
    const normalized = Number.isFinite(next) ? Math.floor(next) : min;
    onChange(Math.min(max, Math.max(min, normalized)));
  };
  const stepButton = 'flex h-9 min-w-9 items-center justify-center rounded-sm border border-solid border-alternative';
  return <div className="flex w-full flex-col gap-lg" data-sentry-component="NumberStepperField" data-sentry-source-file="NumberStepperField.tsx">
      <span className="text-body-lg-bold text-default">{label}</span>
      <div className="flex items-center gap-xs">
        <button type="button" aria-label={`${label} 감소`} aria-disabled={value <= min} onClick={() => {
        if (value <= min) {
          onMinClick?.();
          return;
        }
        commit(value - 1);
      }} className={`${stepButton} bg-neutral ${value <= min ? 'opacity-40' : ''}`}>
          <MinusIcon size="md" fill={ICON_COLOR.default} data-sentry-element="MinusIcon" data-sentry-source-file="NumberStepperField.tsx" />
        </button>
        <input type="number" inputMode="numeric" min={min} max={max} value={Number.isFinite(value) ? value : ''} onChange={event => commit(event.target.valueAsNumber)} aria-label={label} className="h-[46px] w-[200px] rounded-sm border border-solid border-neutral bg-default text-center text-body-lg-semibold text-default outline-none" />
        <button type="button" aria-label={`${label} 증가`} disabled={value >= max} onClick={() => commit(value + 1)} className={`${stepButton} bg-alternative`}>
          <PlusIcon size="md" fill={ICON_COLOR.default} data-sentry-element="PlusIcon" data-sentry-source-file="NumberStepperField.tsx" />
        </button>
      </div>
    </div>;
}